
import {
  hydrateOnInteraction,
  hydrateWhenIdle,
  hydrateWhenVisible,
  hydrateSsrOnly
} from 'vue-lazy-hydration'
import { toPascalCase } from '@/mixin/ds/formatter'
import { myInjectionKey } from '@/mixin/ds/keys'
export default {
  name: 'MATERIAL',
  provide () {
    return {
      [myInjectionKey]: {
        contentArr: this.dataArr,
        exhCnrId: this.exhCnrId,
        exhCmptmtId: this.exhCmptmtId,
        exhMtrlNo: this.exhMtrlNo,
        rndpgUrl: this.rndpgUrl
      }
    }
  },

  inheritAttrs: false,

  props: {
    component: {
      type: String,
      default: null
    },
    componentRef: {
      type: String || Number,
      default: null
    },
    dataArr: {
      type: [Array, Object],
      default: null
    },
    exhCnrId: { // 코너 ID(메인 배너 ID)
      type: String,
      default: ''
    },
    exhCmptmtId: { // 구좌 ID
      type: String,
      default: ''
    },
    exhMtrlNo: { // 소재 ID
      type: String,
      default: ''
    },
    rndpgUrl: { // 전체보기 url
      type: String,
      default: ''
    },
    hydration: {
      type: String,
      default: 'WhenIdle'
    },
    isActiveAccount: {
      type: Boolean,
      default: false
    },
    accountIndex: {
      type: Number,
      default: null
    },
    exhData: {
      type: Object,
      default () {
        return {}
      },
    },
    groobeeRecmData: { // 그루비 추천상품 데이터
      type: Object,
      default () {
        return {}
      }
    },
    pageKey: {
      type: String,
      default: ''
    },
  },

  computed: {
    hydrate () {
      return this[`hydrate${this.hydration}`] ?? null
    },

    name () {
      return this.component ?? this.$attrs.name
    },

    componentLoader () {
      const loaders = ['', ...this.$nuxtDynamic.prefixes]
        .map((prefix) => {
          const name = `Lazy${toPascalCase(prefix)}${toPascalCase(this.name)}`
          return name in this.$nuxtDynamic.loaders
            ? this.$nuxtDynamic.loaders[name]
            : null
        })
        .filter(loader => loader)
      return loaders.shift() ?? null
    },

    lazyComponent () {
      return this.hydrate && this.componentLoader
        // eslint-disable-next-line vue/no-use-computed-property-like-method
        ? this.hydrate(this.componentLoader)
        : this.name
    }
  },
  methods: {
    hydrateOnInteraction,
    hydrateWhenIdle,
    hydrateWhenVisible,
    hydrateNever: hydrateSsrOnly
  }
}
